import { colors } from './abstract/theme.colors';
import { measurements } from './abstract/theme.measurements';
import { typography } from './abstract/theme.typography';
import { zIndex } from './abstract/theme.zindex'

const baseTheme = {
  colors,
  measurements,
  typography,
  zIndex
};

export default baseTheme;
